<template>
    <div class="card-item">
        <p class="card-tit">{{ title }}</p>
        <div class="card-msg">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss">
  .card-item{
    border: 1px solid #E9EBF0;
    box-sizing: border-box;
    .card-tit{
      font-size: 14px;
      color: #333333;
      background-color: #F8FAFD;
      border-bottom: 1px solid #E9EBF0;
      box-sizing: border-box;
      line-height: 34px;
      text-align: center;
    }
    .card-msg{
      padding: 0 10px 5px 10px;
      min-height: 50px;
    }
  }

</style>

<script>
  export default {
    name: 'ZCard',
    props: {
      title: String,  // 标题
    },

    data() {
      return {
      }
    },

    methods: {
    }
  };
</script>


